/* unplugin-vue-components disabled */import script from "./GateBalance.vue?vue&type=script&lang=ts&setup=true"
export * from "./GateBalance.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__